module.exports = __webpack_public_path__ + "static/media/flamme.48341508.svg";